
            const data = {"name":"ic_arrow_top","data":{"width":"13","height":"14","viewBox":"0 0 13 14","data":"<path pid=\"0\" d=\"M1 6.077L6.5 1m0 0L12 6.077M6.5 1v12\" _stroke=\"#3B3BFC\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#3B3BFC"}],"stopColors":[]}}
        
                module.exports = data
                